import './TabContent.css'
import { useCampaign } from '../contexts/CampaignContext'
import OverviewTab from './tabs/OverviewTab'
import QuestsTab from './tabs/QuestsTab'
import LocationsTab from './tabs/LocationsTab'
import NPCsTab from './tabs/NPCsTab'
import ItemsTab from './tabs/ItemsTab'
import SessionsTab from './tabs/SessionsTab'
import MyCharacterTab from './tabs/MyCharacterTab'

function TabContent({ activeTab, activeSubTab, focusEntity, onConsumeFocus }) {
  const { isModuleEnabled } = useCampaign()
  // A tab that has been switched off for this campaign falls back to Overview
  // rather than rendering an empty shell.
  const effectiveTab = isModuleEnabled(activeTab) ? activeTab : 'overview'

  // The id to auto-open, only for the tab that matches the pending wiki-link.
  const focusId = focusEntity && focusEntity.tab === effectiveTab ? focusEntity.id : null

  const renderContent = () => {
    switch (effectiveTab) {
      case 'overview':
        return <OverviewTab />

      case 'character':
        return <MyCharacterTab initialSubTab={activeSubTab} />

      case 'quests':
        return <QuestsTab focusId={focusId} onConsumeFocus={onConsumeFocus} />

      case 'locations':
        return <LocationsTab focusId={focusId} onConsumeFocus={onConsumeFocus} />

      case 'npcs':
        return <NPCsTab focusId={focusId} onConsumeFocus={onConsumeFocus} />

      case 'sessions':
        return <SessionsTab focusId={focusId} onConsumeFocus={onConsumeFocus} />

      case 'items':
        return <ItemsTab focusId={focusId} onConsumeFocus={onConsumeFocus} />

      default:
        return null
    }
  }

  return (
    <main className="content-area">
      <div className="content-wrapper">{renderContent()}</div>
    </main>
  )
}

export default TabContent
